import axios from "axios";

export const BRANCH_URL = "/Branch";
export const COURSE_URL = "/Course";
export const SECTION_URL = "/Section";
export const PRIVATE_NOTICE_URL = "/PrivateNotice";

/** Belli Bir Özel Duyuru Listesini Elde Eder */
export function getPrivateNotices(queryParams) {
  return axios.post(`${PRIVATE_NOTICE_URL}/GetPrivateNotices`, queryParams);
}

/** Belli Bir Özel Duyuru Listesini Sayfalama Olmadan Elde Eder */
export function getAllPrivateNotices(queryParams) {
  return axios.post(`${PRIVATE_NOTICE_URL}/GetAllPrivateNotices`, queryParams);
}

/** Duyuru Yapılacak Belli Bir Öğretmen Listesini Elde Eder */
export function getTeachers(queryParams) {
  return axios.post(`${PRIVATE_NOTICE_URL}/GetTeachers`, queryParams);
}

/** Duyuru Yapılacak Belli Bir Veli Listesini Elde Eder */
export function getParents(queryParams) {
  return axios.post(`${PRIVATE_NOTICE_URL}/GetParents`, queryParams);
}

/** Duyuru Yapılacak Belli Bir Baba Listesini Elde Eder */
export function getFathers(queryParams) {
  return axios.post(`${PRIVATE_NOTICE_URL}/GetFathers`, queryParams);
}

/** Duyuru Yapılacak Belli Bir Anne Listesini Elde Eder */
export function getMothers(queryParams) {
  return axios.post(`${PRIVATE_NOTICE_URL}/GetMothers`, queryParams);
}

/** Duyuru Yapılacak Belli Bir Öğrenci Listesini Elde Eder */
export function getStudents(queryParams) {
  return axios.post(`${PRIVATE_NOTICE_URL}/GetStudents`, queryParams);
}

/** Duyuru Yapılacak Belli Bir Sınıf Listesini Elde Eder */
export function getSectionsForNotice(queryParams) {
  return axios.post(`${PRIVATE_NOTICE_URL}/GetSections`, queryParams);
}

/** Duyuru Yapılan Belli Bir Öğretmen Listesini Elde Eder */
export function getReceipentTeachers(queryParams) {
  return axios.post(`${PRIVATE_NOTICE_URL}/GetReceipentTeachers`, queryParams);
}

/** Duyuru Yapılan Belli Bir Veli Listesini Elde Eder */
export function getReceipentParents(queryParams) {
  return axios.post(`${PRIVATE_NOTICE_URL}/GetReceipentParents`, queryParams);
}

/** Duyuru Yapılan Belli Bir Baba Listesini Elde Eder */
export function getReceipentFathers(queryParams) {
  return axios.post(`${PRIVATE_NOTICE_URL}/GetReceipentFathers`, queryParams);
}

/** Duyuru Yapılan Belli Bir Anne Listesini Elde Eder */
export function getReceipentMothers(queryParams) {
  return axios.post(`${PRIVATE_NOTICE_URL}/GetReceipentMothers`, queryParams);
}

/** Duyuru Yapılan Belli Bir Öğrenci Listesini Elde Eder */
export function getReceipentStudents(queryParams) {
  return axios.post(`${PRIVATE_NOTICE_URL}/GetReceipentStudents`, queryParams);
}

/** Duyuru Yapılan Belli Bir Sınıf Listesini Elde Eder */
export function getReceipentSections(queryParams) {
  return axios.post(`${PRIVATE_NOTICE_URL}/GetReceipentSections`, queryParams);
}

/** Mevcut Okulun Aktif Branş Listesini Elde Eder */
export function getBranches() {
  return axios.get(`${BRANCH_URL}/GetBranches`);
}

/** Mevcut Okulun Aktif Şube Listesini Elde Eder */
export function getSections() {
  return axios.get(`${SECTION_URL}/GetSections`);
}

/** Mevcut Okulun Aktif Ders Listesini Elde Eder */
export function getCourses() {
  return axios.get(`${COURSE_URL}/GetCourses`);
}

/** Yeni Bir Özel Duyuru Elde Eder */
export function getNewPrivateNotice() {
  return axios.get(PRIVATE_NOTICE_URL);
}

/** Belli Bir Özel Duyurunun Detaylarını Elde Eder */
export function getPrivateNotice(id) {
  return axios.get(`${PRIVATE_NOTICE_URL}/${id}`);
}

/** Belli Bir Özel Duyurunun Ekini İndirir */
export function downloadAttachment(id) {
  return axios.get(`${PRIVATE_NOTICE_URL}/DownloadAttachment/${id}`, { responseType: "blob" });
}

/** Belli Bir Özel Duyuruyu Kaydeder */
export function savePrivateNotice(privateNotice) {
  return axios.post(PRIVATE_NOTICE_URL, privateNotice);
}

/** Belli Bir Özel Duyuru Listesini Siler */
export function deletePrivateNotices(ids) {
  return axios.post(`${PRIVATE_NOTICE_URL}/Delete`, ids);
}